





































import Vue from "vue";
import { ListHeader } from "@/components/MyListCard.vue";
// @ts-ignore
import { Base64 } from "js-base64";
import { Header } from "@/components/MyTable.vue";

const infoHeader: ListHeader[] = [
  { title: "密钥名称", key: "name" },
  { title: "密钥描述", key: "description" },
  { title: "类型", key: "type" },
  { title: "创建人", key: "createBy" },
  { title: "创建时间", key: "createTime" }
];
const ConfigListHeader: Header[] = [
  { title: "Key", key: "key", width: 140 },
  { title: "Value", key: "value", minWidth: 400 }
];
export default Vue.extend({
  name: "Overview",
  props: { data: { type: Object } },
  data() {
    return {
      infoHeader,
      ConfigListHeader,
      showValue: false,
      activeNames: []
    };
  },
  methods: {
    getData(item: any) {
      return this.showValue ? Base64.decode(item.value) : item.value;
    }
  }
});
